import React from 'react';
import NoItems from '../../Components/EmptyStates/NoItems';
import { useNavigate } from 'react-router-dom';

const BusinessAddressRequired = () => {
    const navigate = useNavigate();

    return <NoItems
        title={<>
            You need to set your business address so we can show you nearby leads.<br />
            Tap to continue.
        </>}
        icon="LocationQuestion"
        onClick={() => navigate('/business/details')}
    />
}

export default BusinessAddressRequired;
